import React, { FC, memo, useContext } from 'react';
import { makeStyles, tokens, mergeClasses } from '@fluentui/react-components';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';

const useTimeStampStyles = makeStyles({
  root: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground4,
    textAlign: 'center',
  },
});

interface ITimeStampProps {
  time: Date;
}

export function dateTimeFormatter(date: Date, locale: string, timeZone: string | undefined = undefined) {
  const formatter = new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone,
  });

  const formattedDate = formatter.format(date);
  return formattedDate;
}

export const TimeStamp: FC<ITimeStampProps> = memo((props) => {
  const styles = useTimeStampStyles();
  const i18n = useContext(I18nContext) as I18nModel;
  const { time } = props;
  const locale = i18n.getLocale();
  const formattedDate = dateTimeFormatter(time, locale);

  return (
    <div className={mergeClasses(styles.root, 'time-stamp')}>
      {formattedDate}
    </div>
  );
});
